/*
 * @Author: Jay jie.ding@msxf.com
 * @Date: 2024-03-01 17:01:05
 * @LastEditTime: 2025-09-10 16:06:30
 * @FilePath: \vayhFrontend\packages\common\entry\fetchBaseApi.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 拉取项目必备接口，将必要参数获取时机前置
 */

import { runDependOnAppKey, runDependOnUserId } from '@common/helper/observers';
import getChannelMsg from '@common/entry/getInfoFromAPI/getChannelMsg';
import getUserInfo from '@common/entry/getInfoFromAPI/getUserInfo';
import { cookieSetUser, getCookie } from '@common/stores/cookie';
import { getQueryString } from '@common/utils/common';
import { msLocalStorage, msSessionStorage } from '@common/utils/cache';
import { loginByVcode, saveVtoken } from '@common/services/common';

interface IOptions {
  whiteList: string[];
}

// 项目必调接口统一管理
export default (options?: IOptions): Promise<void> => {
  const hostname = window.location.pathname;
  const whiteMenu = options?.whiteList ?? [];

  return new Promise(async (resolve) => {
    const vcode = getQueryString('vcode');
    const vtoken = getQueryString('vtoken');
    const params = {
      channel: getQueryString('channel'),
      appKey: getQueryString('appKey'),
      productCode: getQueryString('productCode'),
      sourceway: getQueryString('sourceway'),
      isPushSource: getQueryString('isPushSource'),
    };
    if (vcode && ![msLocalStorage.get('PUBLIC_VCODE'), getCookie('vcode')].includes(vcode)) {
      // 存在vcode且未使用过，避免重复调用vcode免登
      msLocalStorage.set('PUBLIC_VCODE', vcode);
      // 新框架实现vcode免登
      const result = await loginByVcode({
        vcode,
        ...params,
      });
      // 手动设置cookie
      if (result?.vtoken) {
        cookieSetUser(result?.vtoken);
      }
      // 清除缓存
      msSessionStorage.removeAll([
        'user',
        'PUBLIC_APPKEY',
        'PUBLIC_COOPERATORID',
        // 'PUBLIC_PRODUCTCODE',
      ]);
    } else if (vtoken && getCookie('vtoken') !== vtoken) {
      // 新框架实现vtoken打通node
      await saveVtoken({
        vtoken,
        ...params,
      });
      // 手动设置cookie
      cookieSetUser(vtoken);
      // 清除缓存
      msSessionStorage.removeAll([
        'user',
        'PUBLIC_APPKEY',
        'PUBLIC_COOPERATORID',
        'PUBLIC_PRODUCTCODE',
      ]);
    }

    // 白名单或cookie中无有效令牌时
    if (whiteMenu.includes(hostname) || (!getCookie('vtoken') && !getCookie('msTokenValid'))) {
      resolve();
      return;
    }

    const userPromise = async () => {
      // 获取用户必要信息
      await getUserInfo();
      // 横向传播userId
      document.dispatchEvent(runDependOnUserId);
    };

    const channelPromise = async () => {
      // 获取channel必要信息
      await getChannelMsg();
      // 获取到appKey的话，进行横向数据广播
      document.dispatchEvent(runDependOnAppKey);
    };

    Promise.allSettled([userPromise(), channelPromise()]).finally(resolve);
  });
};
